module.exports = {
    recharge: {
        rechargeTitle: 'Data Recharge',
        loading: 'loading...',
        did: 'DID',
        symbol: '$',
        total: 'total',
        expire: 'expire',
        unpaid: 'Unpaid',
        historicalOrders: 'Historical',
        noOrders: 'no orders',
        orderNo: 'order NO',
        buyTime: 'buy time',
        endTime: 'end time',
        disbursements: 'Discounted',
        cancelOrder: 'cancel',
        pay: 'pay',
        haveDoubts: 'have doubts?',
        renew: 'renew',
        cardNumTips: 'The card number is located as shown in the diagram',
        cardNumOrIccid: 'Please enter 4G card number or ICCID',
        query: 'query',
        tips: 'Tips',
        tips4G1: '1.The iccid number is only entered in the first 19 digits, and it is recommended to obtain it through scanning.',
        tips4G11: '1.The iccid number is only entered in the first 20 digits, and it is recommended to obtain it through scanning.',
        tips4G2: '2.Only current platform subscription traffic packages are supported, and other recharge channels are invalid.',
        tips4G3: '3.SIM cards cannot be used on mobile phones or other mobile devices, and will be immediately suspended upon discovery.',
        msgTips: 'Please enter a valid ICCID',

    }
}

